import axisDe from '../../public/js/resources/de/axis';
import de from '../../public/js/resources/de/main';
import axisEn from '../../public/js/resources/en/axis';
import en from '../../public/js/resources/en/main';

const language = navigator.language.split('-')[0];

// English is default language
let translations = en;
let axisTranslations = axisEn;

// customer language has higher priority
switch (language) {
  case 'de':
    translations = { ...translations, ...de };
    axisTranslations = { ...axisTranslations, ...axisDe };
    break;
  default:
    break;
}

const localize = key => {
  const customerTranslations = window.customerLabels || {};
  return customerTranslations[key] || translations[key];
};

export const localizeAxis = key => {
  const customerTranslations = window.customerLabels || {};
  return customerTranslations[`axis-${key}`] || axisTranslations[key] || translations[key];
};

export default localize;



// WEBPACK FOOTER //
// ./app/util/localizeUtils.js